import {Validation} from '../types/Validations';

export function getFileStatus(
    errorsCount: number,
    validatorsCount: number
): Validation['status'] {
    if (errorsCount > 0 && errorsCount < validatorsCount) {
        return 'warning';
    }

    if (errorsCount === validatorsCount) {
        return 'error';
    }

    return 'success';
}
